var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.1 4.51c1.29.1 2.62.72 3.9 1.98a6.25 6.25 0 0 1 3.9-1.97 4.7 4.7 0 0 1 3.66 1.4c1.82 1.8 2.39 5.06.13 7.3l-.02.03-7.23 6.5a.66.66 0 0 1-.88 0l-7.22-6.5-.02-.03c-2.27-2.25-1.7-5.52.12-7.32A4.7 4.7 0 0 1 8.1 4.51",
    clipRule: "evenodd"
  })));
};
export { SvgHeartFilled as ReactComponent };
export default __webpack_public_path__ + "static/media/heartFilled.a71485fa99370ce2aade83ed0dd487f5.svg";